var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("van-popup", { attrs: { value: _vm.loading, overlay: false } }, [
    _c(
      "div",
      { staticClass: "loading-wrapper" },
      [
        _c("van-loading", { attrs: { size: "48px" } }),
        _c("span", { staticClass: "loading-text" }, [_vm._v("加载中")])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }